<template>
  <!-- Header -->
  <header id="page-header" :class="{ 'in-main': isMain }" style="touch-action: none">
    <slot>
      <!-- Header Content -->
      <div class="omc-header web-centered" :class="{ login: isLogin }">
        <!-- Left Section -->
        <div class="header-shortcuts-wrapper align-items-center">
          <!-- 메인 로고 -->
          <div class="d-flex align-itmes-center" style="gap: 10px">
            <button
              v-if="!isMobile && !isTablet"
              v-click-outside="closeServiceMenu"
              class="header-dropdown-wrapper"
              @click="openServiceMenu"
            >
              <img width="28" height="25" :src="`${$s3}/img/common/Header/menu.svg?${$ver}`" />
              <div v-if="serviceMenu" class="header-dropdown">
                <Menu v-bind="{ closeMenu: closeServiceMenu }" />
              </div>
            </button>

            <base-layout-modifier
              v-else
              action="sidebarOpen"
              variant="alt-none"
              class="sidebar-btn btn d-inline-block d-web-none text-white-main pl-0"
            >
              <img
                width="16"
                height="16"
                :src="`${$s3}/img/common/Header/menu.svg?${$ver}`"
                style="width: clamp(16px, 3vw, 26px); height: auto"
              />
            </base-layout-modifier>

            <router-link :to="{ name: 'Main' }" variant="Main_Logo" class="d-flex align-items-center">
              <img class="logo" width="73" height="25" :src="`${$s3}/img/common/Header/logo.webp?${$ver}`" />
            </router-link>
          </div>

          <!-- GNB 버튼들 -->
          <div v-if="!isTablet" class="shortcuts">
            <template v-for="(shortcut, i) in shortcutsWithHoliday">
              <button
                v-if="!shortcut?.openDate || showMenu(shortcut?.openDate)"
                :key="i"
                class="icn-route-btn"
                :class="shortcut?.cls"
                @click="routeTo(shortcut.route)"
                @mouseover="showTitle(shortcut.img)"
                @mouseleave="hideTitle()"
              >
                <img width="30" height="30" :src="`${$s3}/img/common/Header/${shortcut.img}?${$ver}`" />
                <div v-if="shortcut?.cls && badgeState" class="dot" />
                <!-- <transition name="fade" mode="in-out"> -->
                <div v-if="shownTitle === shortcut.img && !isMobile" class="hover-title">
                  {{ getHoverTitle(shortcut.img) }}
                </div>
                <!-- </transition> -->
              </button>
            </template>
          </div>
        </div>
        <!-- END Left Section -->

        <!-- Right Section -->
        <Clover />

        <OMC />

        <template v-if="!isMobile">
          <router-link
            v-if="!isLogin"
            :to="{ name: 'Login' }"
            class="icn-route-btn my-page"
            variant="alt-none"
            @mouseover.native="showTitle('etc.login')"
            @mouseleave.native="hideTitle()"
          >
            <div class="icon login-icon" />
            <div v-if="shownTitle === 'etc.login'" class="hover-title">
              {{ getHoverTitle('login') }}
            </div>
          </router-link>

          <template v-else>
            <router-link
              v-for="(info, i) in loginStuff"
              :key="i"
              :to="{ name: info.route }"
              class="icn-route-btn my-page"
              variant="alt-none"
              @mouseover.native="showTitle(info.title)"
              @mouseleave.native="hideTitle()"
            >
              <img width="30" height="30" :src="`${$s3}/img/common/Header/${info.route.toLowerCase()}.webp?${$ver}`" />
              <div v-if="shownTitle === info.title" class="hover-title">
                {{ getHoverTitle(info.title) }}
              </div>
            </router-link>

            <button class="icn-route-btn" @mouseover="showTitle('noti')" @mouseleave="hideTitle()" @click="hideTitle()">
              <Alert />
              <div v-if="shownTitle === 'noti'" class="hover-title">
                {{ getHoverTitle('noti') }}
              </div>
            </button>
          </template>
        </template>
        <!-- END Right Section -->
      </div>
      <!-- END Header Content -->

      <div
        v-if="isMobile"
        class="mobile-header d-flex align-items-center justify-content-between"
        :class="{ 'in-main': isMain }"
      >
        <div />
        <!-- Right Section -->
        <div class="d-flex align-items-center justify-content-between">
          <div class="mobile_shortcut d-flex align-items-center">
            <template v-for="(shortcut, i) in shortcutsWithHoliday">
              <button
                v-if="!shortcut?.openDate || showMenu(shortcut?.openDate)"
                :key="i"
                class="shortcut text-white-main no_background pr-0"
                :class="shortcut?.cls"
                @click="routeTo(shortcut.route)"
              >
                <div v-if="shortcut.route === 'Login'" class="icon login-icon" />
                <img v-else width="26" height="26" :src="`${$s3}/img/common/Header/${shortcut.img}?${$ver}`" />
                <div v-if="shortcut?.cls && badgeState" class="dot" />
                <!-- <div class="dot" v-if="true"></div> -->
              </button>
            </template>
          </div>
          <span style="margin-right: 6px">
            <Alert />
          </span>
        </div>
        <!-- END Right Section -->
      </div>
    </slot>
    <Modal id="swap-mobile-header" ref="swap-mobile-header" />
  </header>
  <!-- END Header -->
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import Menu from '@/layouts/partials/Menus/Menu';
import Alert from '@/layouts/partials/Alert/Alert';
import OMC from '@/layouts/partials/OMC';
import Clover from '@/layouts/partials/Clover';
import Modal from '@/views/Components/Modal';

const SHORTCUTS_KO = [
  { route: 'Land', img: 'map.svg' },
  { route: 'Subscription information', img: 'subs.svg' },
  { route: 'Community', img: 'community.svg' },
  { route: 'Guide', img: 'guide.svg', cls: 'guide' },
  { route: 'EventHome', img: 'event.svg', openDate: '2023-03-13' },
  { route: 'Store', img: 'store.svg' },
  { route: 'Swap', img: 'swap.webp' },
];

const SHORTCUTS_EN = [
  { route: 'Land', img: 'map.svg' },
  { route: 'Subscription information', img: 'subs.svg' },
  { route: 'Guide', img: 'guide.svg', cls: 'guide' },
  { route: 'EventHome', img: 'event.svg', openDate: '2023-03-13' },
  { route: 'Store', img: 'store.svg' },
  { route: 'Swap', img: 'swap.webp' },
];
const LOGIN_STUFF = [
  { route: 'Assets', title: 'property', img: 'assets.webp' },
  { route: 'MyPage', title: 'mypage', img: 'mypage.webp' },
];

const loginStuff = (isLogin) => (isLogin ? LOGIN_STUFF : [{ route: 'Login', img: 'menu/my.svg' }]);

export default {
  name: 'BaseHeader',
  components: {
    Menu,
    Alert,
    OMC,
    Clover,
    Modal,
  },
  data() {
    return {
      modal: null,
      shownTitle: '',
      titleTimeout: null,
      serviceMenu: false,
      loginStuff: LOGIN_STUFF,
    };
  },
  computed: {
    ...mapState([
      'isPhone',
      'isLogin',
      'userId',
      'newNoti',
      'newProperty',
      'newAnnounce',
      'isMobile',
      'isTablet',
      'lang',
      'badgeState',
      'city',
    ]),
    ...mapGetters({
      holidayDate: 'holidayDate',
      holiday: 'holidayName',
    }),
    shortcutsWithHoliday() {
      const myPage = loginStuff(this.isLogin);

      if (this.lang === 'ko') return this.isMobile ? [...SHORTCUTS_KO, ...myPage] : [...SHORTCUTS_KO];

      return this.isMobile ? [...SHORTCUTS_EN, ...myPage] : [...SHORTCUTS_EN];
    },
    loginBtnTitle() {
      return this.isLogin ? 'property' : 'etc.login.title';
    },
    isMain() {
      return this.$route.name === 'Main';
    },
  },
  mounted() {
    this.modal = this.$refs?.['swap-mobile-header'];
  },
  methods: {
    showMenu(date) {
      if (!date) return false;
      else {
        const now = this.$DateTime.now();
        const openDate = this.$tl(date, this.lang);

        return now > openDate;
      }
    },
    ...mapActions({
      getLogout: 'logout',
    }),
    isInThePeriod() {
      if (!this.holidayDate) return false;

      const setMidnight = (date) => {
        const [dateWithoutTime] = date?.split('T');
        return this.$tl(dateWithoutTime, this.lang);
      };
      const d1 = this.holidayDate?.start,
        d2 = this.holidayDate?.end;
      const dateNow = this.$DateTime.now().toISO();
      const nowToMidnight = setMidnight(dateNow);
      const date1 = setMidnight(d1);
      const date2 = setMidnight(d2);

      return nowToMidnight >= date1 && nowToMidnight <= date2;
    },
    readAnnounce() {
      this.$store.commit('readAnnounce');
      const localAnnounce = JSON.parse(localStorage.getItem('localAnnounce'));
      localStorage.setItem('readAnnounce', JSON.stringify(localAnnounce));
    },
    routeToSwap() {
      window.location.href = process.env.VUE_APP_SWAP_URL;
    },
    routeTo(routeName) {
      if (this.$route.name === routeName) return this.$router.go(0);

      if (routeName === 'Swap') return this.routeToSwap();
      if (routeName === 'Land') return this.$router.push({ path: `/map`, query: { city: this.city } });
      if (routeName === 'Guide') {
        this.$gtag.event('가이드페이지', {
          event_category: '가이드',
          event_label: '가이드페이지',
        });
      }
      this.$router.push({ name: routeName });
    },
    logout() {
      this.getLogout().then(() => {
        this.$route.name !== 'Main' && this.$router.push({ name: 'Main' });
        this.$bvModal.show('logout');
      });
    },
    getHoverTitle(titleOrigin) {
      const [title] = titleOrigin.split('.');

      switch (title) {
        case 'subs':
          return this.$t('subscription.title');
        case 'swap':
          return this.$t('etc.swap.title');
        case 'login':
          return this.$t('etc.login.title');

        default:
          return this.$t(`${title}.title`);
      }
    },
    showTitle(title) {
      this.titleTimeout = setTimeout(() => {
        this.shownTitle = title;
      }, 300);
    },
    hideTitle() {
      clearTimeout(this.titleTimeout);
      this.titleTimeout = null;
      this.shownTitle = '';
    },
    openServiceMenu() {
      if (this.serviceMenu) return;
      const pageContainer = document.getElementById('page-container');
      const scrollPosition = window.scrollY;
      pageContainer.style.position = 'fixed';
      pageContainer.style.top = `-${scrollPosition}px`;
      // pageContainer.classList.add('block-scroll');

      this.serviceMenu = true;
    },
    closeServiceMenu() {
      if (!this.serviceMenu) return;
      const pageContainer = document.getElementById('page-container');
      const scrollPosition = pageContainer.style.top;
      pageContainer.style.position = '';
      pageContainer.style.top = '';
      window.scrollTo(0, parseInt(scrollPosition || '0') * -1);
      // pageContainer.classList.remove('block-scroll');

      this.serviceMenu = false;
    },
  },
};
</script>

<style lang="scss">
.login-icon {
  width: 32px;
  height: 32px;
  background: white;

  @include tablet {
    width: 23px;
    height: 23px;
  }
}

.omc-header {
  .icn-route-btn {
    padding: 0;

    @include tablet {
      padding: 6px !important;
      padding-right: 0px !important;
    }

    img:not(.close) {
      height: 30px;
    }
  }
}
.mobile_shortcut {
  display: flex;
  gap: 3px;

  .shortcut {
    padding: 6px !important;

    &.guide {
      @include mobile {
        display: none;
      }
    }
  }

  img {
    height: 23px;
  }
}
</style>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.mobile-header {
  width: 100%;
  height: 40px;
  background: var(--header-color);

  &.in-main {
    background: transparent;
  }
}

#page-header {
  background: var(--header-color);

  &.in-main {
    background: transparent;
    position: absolute;
    top: 0;
    z-index: 2;
    @include tablet {
      position: fixed;
      background: black;
    }
  }
  .header-dropdown-wrapper {
    height: fit-content;
    margin-right: 10px;
    position: relative;

    .header-dropdown-btn {
      color: white;
      font-size: 30px;
      cursor: pointer;
    }

    .header-dropdown {
      position: absolute;
      overflow: auto;
      max-height: calc(calc(var(--vh, 1vh) * 100) - 140px);
      top: 53px;
      transition: all 0.15s ease-in-out;
      box-shadow: 0px 5px 5px #3333332f;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }

  .omc-header {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 24px;
    align-items: center;
    margin: 0 auto;
    height: 80px;
    z-index: 1040;

    .logo {
      width: 73px;
      height: auto;
    }

    @include tablet {
      grid-template-columns: 1fr;
    }

    &.login {
      grid-template-columns: 1fr repeat(5, auto);

      @include tablet {
        grid-template-columns: 1fr repeat(2, auto);
      }
    }

    @include tablet {
      grid-template-columns: 1fr repeat(2, auto);
      gap: 6px;
      padding: 0 12px;
      height: 40px;

      .sidebar-btn {
        padding: 0 6px;

        .sidebar-btn-img {
          width: 30px;
          height: 30px;
        }
      }
      .logo {
        width: 60px;
      }
    }
    .header-shortcuts-wrapper {
      display: flex;
      gap: 50px;

      @include tablet {
        gap: 0px;
      }

      .shortcuts {
        display: flex;
        gap: 28px;
      }
    }
  }

  .icn-route-btn {
    position: relative;

    &.holiday {
      position: relative;
      padding: 0 !important;
      width: 35px;
      height: 35px;
      img {
        width: 100%;
        height: 100%;
      }

      .dot {
        position: absolute;
        top: 8px;
        right: -4px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: red;
        transform: translate(-50%, -50%);

        @media screen and (max-width: 1120px) {
          top: 7px;
          right: 0px;
          transform: scale(0.65);
        }
      }
    }

    .hover-title {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, 100%);
      background: #3e4144;
      border-radius: 2px;
      color: #ffffff;
      font-weight: 400;
      font-size: 12px;
      padding: 0 4px;
      word-break: keep-all;
      white-space: nowrap;
    }
  }
}
#beta-wrapper {
  position: relative;
  .beta {
    position: absolute;
    top: -2px;
    right: -33px;
    scale: 1.2;

    @include tablet {
      width: 12px;
      height: 8px;
      top: 17px;
      right: -9px;
      scale: 1;
    }
  }
}
</style>

<style lang="postcss" scoped>
.guide_btn:hover {
  color: white;
  font-weight: 600;
}
.filter-green {
  filter: invert(81%) sepia(10%) saturate(12%) hue-rotate(4deg) brightness(82%) contrast(82%);
}
.omc-header a {
  font-size: 18px;
}
ul {
  list-style: none;
  padding-left: 0px;
  overflow: auto;
}
.alert_img {
  position: relative;
  display: inline-block;
  /* margin: 4px 0px 4px 8px; */
}
.img_badge {
  position: absolute;
  top: -1px;
  right: -1px;
  padding: 5px;
  border-radius: 50%;
  background: red;
  color: white;
}
::v-deep .border_0 {
  border-width: 0;
}
.alert_width {
  width: 369px;
}
@media screen and (max-width: 992px) {
  .alert_width {
    width: calc(100vw - 15px);
  }
}
</style>
